import {DateTime} from 'luxon';

export enum TemplateActivityLogType {
  Duplicate = 50,
  Import = 90,
  Publish = 100,
}

export enum PublishType {
  AfterEffect,
  Figma,
  Photoshop,
}

export interface RemoteTemplateLogItem {
  actionTime: string;
  actionType: TemplateActivityLogType;
  affectedAdSizes: string[];
  id: number;
  link: string;
  userId: number;
  userName: string;
  sourceTemplateId: number;
  publishType: PublishType;
}

export interface TemplateLogItem extends Omit<RemoteTemplateLogItem, 'actionTime'> {
  actionTime: DateTime;
}

export interface ActivityLogData {
  affectedAdSizes: string[];
  file: File;
  publishType: PublishType;
}
